module.exports = __webpack_public_path__ + "static/media/shadow.ebd271d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/icons/shadow.png
// module id = 443
// module chunks = 0